import React, { useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';

const Showreel = () => {
  const showreelRef = useRef(null);
  const iframeRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (iframeRef.current && iframeRef.current.contentWindow) {
          const player = iframeRef.current.contentWindow;
          // Pause atau play berdasarkan visibilitas
          player.postMessage(
            JSON.stringify({
              event: 'command',
              func: entry.isIntersecting ? 'playVideo' : 'pauseVideo',
              args: [],
            }),
            '*'
          );
        }
      },
      { threshold: 0.4 }
    );

    if (showreelRef.current) observer.observe(showreelRef.current);
    return () => observer.disconnect();
  }, []);

  const toggleMute = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      const player = iframeRef.current.contentWindow;
      player.postMessage(
        JSON.stringify({
          event: 'command',
          func: isMuted ? 'unMute' : 'mute',
          args: [],
        }),
        '*'
      );
      setIsMuted(!isMuted);
    }
  };

  return (
    <section
      id="showreel"
      ref={showreelRef}
      className="py-20 lg:py-32 bg-white dark:bg-gray-900 transition-all duration-1000"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Judul */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Showreel Terbaru
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Saksikan highlight karya-karya terbaik kami dalam satu video yang menginspirasi
          </p>
        </div>

        {/* YouTube Video */}
        <div className="relative max-w-5xl mx-auto rounded-2xl overflow-hidden shadow-2xl aspect-video">
          <iframe
            ref={iframeRef}
            className="w-full h-full rounded-2xl"
            src={`https://www.youtube.com/embed/VV6sPH3gF9k?autoplay=1&loop=1&mute=1&playlist=VV6sPH3gF9k&modestbranding=1&controls=0&showinfo=0&rel=0&enablejsapi=1`}
            title="Creativa Showreel 2025"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          ></iframe>


          {/* Tombol suara custom */}
          <button
            onClick={toggleMute}
            className="absolute bottom-4 right-4 bg-black/60 hover:bg-black/80 text-white p-3 rounded-full transition duration-200"
            aria-label="Toggle Mute"
          >
            {isMuted ? <VolumeX size={22} /> : <Volume2 size={22} />}
          </button>
        </div>

        {/* Deskripsi */}
        <div className="mt-8 text-center">
          <h3 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
            Creativa Showreel 2025
          </h3>
          <p className="text-gray-600 dark:text-gray-400">
            Koleksi karya visual terbaik kami sepanjang tahun
          </p>
        </div>
      </div>
    </section>
  );
};

export default Showreel;
